const trimTrailingSlash = (value: string) => value.replace(/\/+$/, "");

const numericQueryValue = (value: string | number | null | undefined) => {
  if (value === "" || value == null) {
    return null;
  }

  const normalized = String(value).trim();
  return /^\d+$/.test(normalized) ? encodeURIComponent(normalized) : null;
};

export const getIntouchTrainingPageUrl = (): string | null => {
  const origin = process.env.GATSBY_INTOUCH_ORIGIN?.trim();
  const endpoint = process.env.GATSBY_INTOUCH_TRAININGS_ENDPOINT?.trim();

  if (!origin || !endpoint) {
    return null;
  }

  const normalizedEndpoint = endpoint.startsWith("/")
    ? endpoint
    : `/${endpoint}`;

  return `${trimTrailingSlash(origin)}${trimTrailingSlash(normalizedEndpoint)}`;
};

export const getIntouchTrainingTargetUrl = (
  courseId: string | number,
  sessionId?: string | number | null
): string | null => {
  const baseUrl = getIntouchTrainingPageUrl();
  const target = numericQueryValue(courseId);

  if (!baseUrl || !target) {
    return null;
  }

  const session = numericQueryValue(sessionId);
  const sessionQuery = session ? `&session=${session}` : "";

  return `${baseUrl}?target=${target}${sessionQuery}`;
};
